import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { uniqueIdentifier } from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const record = Object.entries(this.props.record);
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCloseClick}
          centered={false}
        >
          <ModalBody>
            <Row>
              <Col lg={12}>
                <div className="modal-header">
                  <i
                    className="mdi mdi-trash-can-outline"
                    style={{ fontSize: "3em", color: "red" }}
                  />
                  <h4 className="modal-body" id="staticBackdropLabel">
                    {this.props.t("areYouSureYouWantToDelete")}
                  </h4>
                </div>
                <div className="modal-body" style={{ fontSize: "1.1em" }}>
                  <table>
                    <tbody>
                      {record.length > 0 &&
                        record.map(
                          ([key, val], i) =>
                            key != "guid" && (
                              <tr key={uniqueIdentifier()}>
                                <th scope="row">{this.props.t(key)} </th>
                                <td> :</td>
                                <td>{val}</td>
                              </tr>
                            )
                        )}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    onClick={this.props.onDeleteClick}
                  >
                    {this.props.t("delete")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={this.props.onCloseClick}
                  >
                    {this.props.t("cancel")}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

DeleteModal.propTypes = {
  onDeleteName: PropTypes.any,
  onCloseClick: PropTypes.func,
  record: PropTypes.any,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(DeleteModal);
